import ComImage from "./ComImage";
import ComText from "./ComText";
import ComCarousel from "./ComCarousel";

export default function Commercial() {
  return (
    <>
      <ComImage />
      <ComText />
      <ComCarousel />
    </>
  );
}
